import { ISSUANCE_URL, RETURN_ISSUANCE_URL } from '../../CONSTANTS';
import { callGetAxios, callPostAxios, callPutAxios } from '../common/common';

export const getIssuanceReport = (data) => {
    return callPostAxios(ISSUANCE_URL() + 'getIssuanceReport', data, 'getIssuanceReport');
};

export const getRecordByDepartmentId1 = (data) => {
    return callPostAxios(ISSUANCE_URL() + 'getRecordByDepartmentId', data, 'getRecordByDepartmentId1');
};

export const getIssuanceDetail = (id) => {
    return callGetAxios(ISSUANCE_URL() + id, 'getIssuanceDetail');
};

// for issuance no and uuid
export const getIssuanceKeyValueList = () => {
    return callGetAxios(ISSUANCE_URL() + 'getKeyValueList', 'getIssuanceKeyValueList');
};

export const getIssuanceRecords = (data) => {
    return callPostAxios(ISSUANCE_URL() +  'getAllRecords', data, 'getIssuanceRecords');
};

export const addIssuance = (data) => {
    return callPostAxios(ISSUANCE_URL(), data, 'addIssuance');
};

export const updateIssuance = (id, data) => {
    return callPutAxios(ISSUANCE_URL() + id, data, 'updateIssuance');
};

export const returnIssuanceUnitEnum = () => {
    return callGetAxios(RETURN_ISSUANCE_URL() + 'statusType', 'getReturnIssuanceEnums')
}

export const returnIssuanceItems = (data) => {
    return callPostAxios(RETURN_ISSUANCE_URL() + 'returnIssued', data, 'getReturnIssuanceItems')
}